<template>
  <div v-if="discriminaIva">
    <div class="caption grey--text mb-2">
      IVA del producto
      <span class="ml-1">· el rubro contable lo elige el sistema</span>
    </div>
    <v-chip-group
      :value="value"
      column
      active-class="primary--text"
      @change="$emit('input', $event === undefined ? null : $event)"
    >
      <v-chip
        v-for="a in alicuotas"
        :key="a.id"
        :value="a.id"
        filter
        outlined
        small
      >
        {{ a.descripcion }}
      </v-chip>
    </v-chip-group>
    <div v-if="!value" class="caption grey--text">
      Sin elegir: usa el rubro por defecto de cada sucursal.
    </div>
  </div>
</template>

<script>
import axios from "axios";

// Las opciones son de la empresa y no cambian en la sesión: una sola consulta
let opcionesCache = null;

/**
 * Alícuota de IVA del producto en chips (21%, 10,5%...). Quien carga elige la
 * alícuota, no el rubro. Si la empresa no discrimina IVA (monotributista) no
 * se muestra.
 */
export default {
  name: "AlicuotaIvaChips",
  props: {
    value: { type: Number, default: null },
  },
  data() {
    return {
      alicuotas: [],
      discriminaIva: false,
    };
  },
  async created() {
    try {
      if (!opcionesCache) {
        opcionesCache = axios.get("/productos/productos/opciones").then((r) => r.data);
      }
      const opciones = await opcionesCache;
      // Las que se usan en la práctica primero; el resto (0%, 2,5%...) después
      const orden = ["21%", "10.5%", "27%"];
      this.alicuotas = [...(opciones.alicuotas_iva || [])].sort((a, b) => {
        const ia = orden.indexOf(a.descripcion);
        const ib = orden.indexOf(b.descripcion);
        return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
      });
      this.discriminaIva = !!opciones.discrimina_iva;
    } catch (e) {
      opcionesCache = null;
    }
  },
};
</script>
